// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"89ed8624","232":"a1a47473","237":"996c6ef3","526":"a53a3446","787":"097a02c3","872":"1d9237e7"}[chunkId] + ".chunk.js";
};